import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import appConfig from 'config/app.config';
import {getText,  renderMarkdown} from 'helpers/text-helper';

import MultipleChoice from './multiple-choice/multiple-choice';
import './game-step-questions.scss';

const GameStepQuestions = ({languageId, deviceInfo, gameStepData, groupData, goToNextGameStep}) => {
	/* Timeout */
	const timeout = useRef(null);

	/* Loading status */
	const [isLoading, setIsLoading] = useState(false); 

	/* Get game step question(s) */
	const questions = gameStepData.questions ? gameStepData.questions : [];

	/**
	 * Answer a question
	 * @param {string} questionId 
	 * @param {string} optionId 
	 * @returns 
	 */
	const handleAnswerQuestion = (questionId, optionId) => {
		return new Promise((resolve) => {
			if (isLoading) {
				resolve({status: 'error', error: 'loading'});
			} else {
				setIsLoading(true);
				const questions = groupData.questions ? JSON.parse(JSON.stringify(groupData.questions)) : [];
				const questionIndex = questions.findIndex((q) => {return q.questionId === questionId;});
				if (questionIndex < 0) {
					questions.push({questionId, optionId});
				} else {
					questions[questionIndex].optionId = optionId;
				}
				const db = firebase.firestore();
				db.collection(appConfig.groupsDbName).doc(groupData.id).update({questions}).then(() => {
					setIsLoading(false);
					if (timeout.current) clearTimeout(timeout.current);
					timeout.current = setTimeout(() => {
						goToNextGameStep();
					},  500);
					resolve({status: 'success'});
				}).catch((error) => {
					console.error(error);
					setIsLoading(false);
				});
			}
		});
	};

	return (
		<div id='questions' className={'GameStepQuestions ' + deviceInfo.orientation}>
			<div id='top'/> {/* Lazy solution to get scroll to top to work */}
			{gameStepData.title && <div className="GameStepQuestions-title">
				<span>{getText(gameStepData.title, languageId)}</span>
			</div>}
			{gameStepData.text && <div className="GameStepQuestions-text">
				{renderMarkdown(getText(gameStepData.text, languageId))}
			</div>}
			<div className={'GameStepQuestions-questions ' + (questions.length > 1 ? ' multiple' : '')}>
				{questions.map((question, index) => {
					return (
						<div 
							key={index} 
							className={'GameStepQuestions-question ' 
							+ question.type + (question.subtype ? ' ' + question.subtype : '')}
						>
							<MultipleChoice 
								languageId={languageId}
								deviceInfo={deviceInfo}
								question={question}
								groupData={groupData}
								handleAnswerQuestion={handleAnswerQuestion}
							/>
						</div>
					);
				})}
			</div>
		</div>
	);
};

GameStepQuestions.propTypes = {
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	gameStepData: PropTypes.object.isRequired,
	groupData: PropTypes.object.isRequired,
	goToNextGameStep: PropTypes.func.isRequired
};

export default GameStepQuestions;